<div class="needs-attention"
     data-testid="job-needs-attention-container">
  <schedule-detail-header [title]="title()"
                          [subtitle]="subtitle() | titlecase "
                          [backCallback]="goBack.bind(this)"
                          [showCloud]="true"
                          [isRefreshingInBackground]="isRefreshingInBackground()"></schedule-detail-header>
  @if (dataLoaded()) {

    <div class="needs-attention-container"
         [appDataUpdatedFade]="dataUpdatedPulse()">
      <div class="details"
           [formGroup]="form">
        <div [innerHTML]="assertionText()"
             class="title-text"
             data-testid="job-needs-attention-text-assertion">
        </div>
        <div class="assertions">
          <app-form-field [label]="isLockedAcceptedCarryover() ? '' : 'Add Photos'"
                          [required]="isIssue() && !isLockedAcceptedCarryover()"
                          [labelSuffix]="isLockedAcceptedCarryover() ? '' : '(Max ' + maxPhotos + ')'"
                          [control]="form.controls.photos"
                          [invalid]="isInvalid('photos')"
                          [errorMessages]="{ required: 'Photos are required' }">
            <app-photo-capture inputId="needs-attention"
                               [images]="photoThumbnails()"
                               [invalid]="isInvalid('photos')"
                               [disabled]="imageCompressionPipelineService.isCompressingImages()"
                               [hideCaptureButtons]="isLockedAcceptedCarryover()"
                               [loading]="imageCompressionPipelineService.isLoadingImages()"
                               [optimizing]="imageCompressionPipelineService.isCompressingImages()"
                               [processingCount]="imageCompressionPipelineService.numberOfImagesBeingProcessed()"
                               (filesSelected)="onPhotosSelected($event)"
                               (imageClicked)="openImagesModal($event)"
                               testId="job-needs-attention" />
          </app-form-field>
          @if (isLockedAcceptedCarryover()) {
            <label class="locked-notes-label body-md-regular"
                   data-testid="job-needs-attention-notes-label">{{ form.controls.notes.value }}</label>
          } @else {
            <app-form-field label="Notes"
                            inputId="notes"
                            [required]="isIssue()"
                            [control]="form.controls.notes"
                            [invalid]="isInvalid('notes')"
                            [maxLength]="maxNoteLength"
                            [errorMessages]="{ required: 'Notes are required' }">
              <app-textarea inputId="notes"
                            formControlName="notes"
                            [maxLength]="maxNoteLength"
                            [showCount]="false"
                            [invalid]="isInvalid('notes')"
                            testId="job-needs-attention-textarea-notes" />
            </app-form-field>
          }
          <div *ngIf="isIssue() && isCcmInspection()">
            <app-form-field label="Severity"
                            [required]="true"
                            [control]="form.controls.severity"
                            [invalid]="isInvalid('severity')"
                            [errorMessages]="{ required: 'Severity is required' }">
              <app-horizontal-button-group [buttons]="severityButtons"
                                           testId="job-needs-attention-severity-levels" />
              <app-severity-info [severity]="form.controls.severity.value"
                                 testId="job-needs-attention-text-severity-info" />
            </app-form-field>

          </div>
          @if (isIssue() && isCcmInspection() === false) {

            <app-form-field label="Vendor"
                            inputId="bq-job-cm-issue-vendor">
              @if (vendors().length > 0) {
                <app-select-field inputId="bq-job-cm-issue-vendor"
                                  [filter]="true"
                                  formControlName="externalVendorId"
                                  [options]="vendorOptions()"
                                  optionLabel="name"
                                  optionValue="id"
                                  placeholder="Select Vendor"
                                  [showClear]="true"
                                  testId="bq6-issue-vendor-select">
                  <ng-template #selectOptionItem
                               let-option
                               let-label="label">
                    @if (option.id === selfAssignedVendorId) {
                      <span class="bqa-pinned-select-option"
                            data-testid="bq6-issue-assign-to-me-option">{{ assignToMeLabel }}</span>
                    } @else {
                      {{ label }}
                    }
                  </ng-template>
                </app-select-field>
              }
              @else {
                <p-skeleton height="44px" />
              }
            </app-form-field>

            <app-form-field label="Due Date"
                            inputId="due-date">
              <div class="due-date-section"
                   data-testid="due-date-section">
                <p-datepicker formControlName="dueDate"
                              (onShow)="onCalendarShow()"
                              (onHide)="onCalendarHide()"
                              (onBlur)="onCalendarHide()"
                              [showIcon]="true"
                              icon="pi pi-calendar"
                              placeholder="Select Date"
                              styleClass="due-date-calendar"
                              data-testid="due-date-calendar"
                              inputId="due-date"
                              [attr.aria-label]="'Select due date for issue. Current date: ' + (issue().dueDate ? (issue().dueDate | date:'MM/dd/yyyy') : 'None selected')"
                              appendTo="body">
                </p-datepicker>

                <!-- Custom backdrop overlay -->
                @if (isCalendarOpen()) {
                  <div class="calendar-backdrop"
                       (click)="onCalendarHide()"
                       data-testid="calendar-backdrop"
                       role="presentation"
                       aria-hidden="true"></div>
                }
              </div>
            </app-form-field>
          }
        </div>
        <app-vertical-button-group [buttons]="footerButtons"
                                   testId="job-needs-attention-footer" />
      </div>
    </div>

  }

  <p-confirmdialog>
  </p-confirmdialog>

</div>